import { useState } from "react";
import { BiLogoTelegram } from "react-icons/bi";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

export default function MessageForm() {
  const [selectedCategory, setSelectedCategory] = useState("Civil Materials");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const categories = [
    "Civil Materials",
    "Bath & Sanitary",
    "Tiles & Flooring",
    "Ply & Laminate",
    "Electrical",
    "Paints",
    "Doors & Windows",
    "Interiors",
    "Hardware",
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.phone || !formData.email) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill in all required fields!",
      });
      return;
    }

    setIsLoading(true);

    try {
      const SERVICE_ID = "service_2xoccc8";
      const TEMPLATE_ID = "template_vjaiqgp";
      const PUBLIC_KEY = "rGb5ZE12MTniKkDTp";

      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        category: selectedCategory,
        message: formData.message,
        to_name: "BrickNBar",
      };

      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);

      Swal.fire({
        title: "Message sent successfully!",
        icon: "success",
        draggable: true,
      });

      setFormData({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
      setSelectedCategory("Civil Materials");
    } catch (error) {
      console.error("EmailJS Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: '<a href="#">Why do I have this issue?</a>',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full mx-auto p-3 rounded-lg">
      <div className="mb-6">
        <h3 className="text-gray-700 font-semibold mb-4">
          I'm interested in...
        </h3>
        <div className="grid grid-cols-3 gap-2">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-3 py-2 sm:text-sm text-xs rounded transition-colors ${
                selectedCategory === category
                  ? "bg-[#CB593F] text-white"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <input
            type="text"
            name="name"
            placeholder="Your name"
            value={formData.name}
            onChange={handleInputChange}
            className="w-full px-0 py-3 text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 placeholder-gray-400 focus:outline-none focus:border-red-500"
          />
        </div>

        <div>
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleInputChange}
            className="w-full px-0 py-3 text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 placeholder-gray-400 focus:outline-none focus:border-red-500"
          />
        </div>

        <div>
          <input
            type="email"
            name="email"
            placeholder="Your email"
            value={formData.email}
            onChange={handleInputChange}
            className="w-full px-0 py-3 text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 placeholder-gray-400 focus:outline-none focus:border-red-500"
          />
        </div>

        <div>
          <input
            name="message"
            placeholder="Your message"
            value={formData.message}
            onChange={handleInputChange}
            rows={3}
            className="w-full px-0 py-3 text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 placeholder-gray-400 focus:outline-none focus:border-red-500 resize-none"
          />
        </div>
        <div className="flex justify-end items-center">
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className={`sm:w-3/5 w-full py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 mt-6 ${
              isLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#CB593F] hover:bg-orange-700"
            } text-white`}
          >
            <BiLogoTelegram size={22} />
            {isLoading ? "Sending..." : "Send Message"}
          </button>
        </div>
      </div>
    </div>
  );
}
